<script setup lang="ts">
import { type Props, setup } from './rightPanelSubMenuElement.setup';

const props = defineProps<Props>();

const { onClickElement } = setup(props);
</script>

<template>
  <li
    :class="['right-panel-element sub-menu-element', { selected }]"
    @click="onClickElement"
  >
    <ev-icon
      v-if="menuInfo.meta?.prefixIcon"
      :icon="menuInfo.meta.prefixIcon"
    />
    <div class="sub-menu-element__inner-text right-panel-element__inner-text">
      <span class="right-panel-element__inner-text-text">
        {{ menuInfo.text }}
      </span>
      <span
        v-if="menuInfo.meta?.menuIcon || menuInfo.meta?.menuIconLabel"
        class="right-panel-element__inner-text-icon"
      >
        <span>{{ menuInfo.meta?.menuIconLabel }}</span>
        <ev-icon
          v-if="menuInfo.meta?.menuIcon"
          :icon="menuInfo.meta.menuIcon"
          size="small"
        />
      </span>
    </div>
  </li>
</template>

<style lang="scss">
.right-panel-element {
  &__inner-text {
    justify-content: space-between;
    width: 100%;
    padding-left: 0 !important;

    span {
      margin-right: 0 !important;
    }

    &-icon {
      // sub-menu-element__inner-text span scss로 인해 영향 받지 않도록 설정
      display: flex !important;
      gap: 4px;
      align-items: center;
      visibility: hidden;

      .sub-menu-element:hover & {
        visibility: visible;
      }

      span {
        font-size: 11px;
        font-weight: 500;
        line-height: 1.2;
        color: var(--color-gray-03-07);
      }
    }

    i {
      background-color: var(--color-gray-03-07);
    }
  }
}
.right-panel-sub-menu__help-manual-icon {
  margin-right: 2px;
}
</style>
